import { RootState } from "../store";
import { createSelector } from '@reduxjs/toolkit'

export const selectPopupItems = createSelector(
    (state: RootState) => state.popup.items,
    items => items
);

export const selectPopupsCount = createSelector(
    (state: RootState) => state.popup.items,
    items => items.length
);

export const selectWizardStep = createSelector(
    (state: RootState) => state.popup.wizardStep,
    wizardStep => wizardStep,
);

export const selectIsQuickSave = createSelector(
    (state: RootState) => state.popup.isQuickSave,
    item => item,
);